export default {
  apiVersion: 2,
  development: {
    accessToken: '6a129cb995fb4ba1f9d7cf5513d15713',
    url: 'http://api.duos.dev.moya.is/_/moya/pilot/api',
  },
  staging: {
    accessToken: '6a129cb995fb4ba1f9d7cf5513d15713',
    url: 'https://api.duos.is/_/moya/pilot/api',
  },
  production: {
    accessToken: '6a129cb995fb4ba1f9d7cf5513d15713',
    url: 'https://api.duos.is/_/moya/pilot/api',
  },
};
